var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStockTakeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 75,
    height: 67.946,
    viewBox: "0 0 75 67.946",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_11158",
    x: 0,
    y: 10.856,
    width: 36.217,
    height: 38.576,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_11160",
    x: 18.216,
    y: 10.1,
    width: 37.833,
    height: 39.332,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_11166",
    x: 30.22,
    y: 17.261,
    width: 44.78,
    height: 50.685,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "stock",
    transform: "translate(9 -0.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9473",
    "data-name": "Group 9473",
    transform: "translate(0 17.056)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9472",
    "data-name": "Group 9472"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -16.86)",
    filter: "url(#Path_11158)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11158-2",
    "data-name": "Path 11158",
    d: "M18.217,154.421v14.753a1.982,1.982,0,0,1-1.982,1.982H1.305a29.151,29.151,0,0,1,.5-18.715H4.979l4.082,1.335,2.585-1.335,2.792-1.861,1.8,1.861a1.982,1.982,0,0,1,1.982,1.981Z",
    transform: "translate(9 -133.72)",
    fill: "#ffe471"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_11159",
    "data-name": "Path 11159",
    d: "M50.337,173.317l-.572-.732a.34.34,0,0,0-.536,0l-.575.736a.34.34,0,0,1-.536,0l-.575-.736a.34.34,0,0,0-.536,0l-.575.736a.34.34,0,0,1-.536,0l-.575-.736a.34.34,0,0,0-.536,0l-.572.732a.151.151,0,0,1-.271-.093V167h6.666v6.226A.152.152,0,0,1,50.337,173.317Z",
    transform: "translate(-38.963 -165.137)",
    fill: "#ff9a6e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9475",
    "data-name": "Group 9475",
    transform: "translate(18.216 16.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9474",
    "data-name": "Group 9474"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -27.22, -16.1)",
    filter: "url(#Path_11160)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11160-2",
    "data-name": "Path 11160",
    d: "M178.607,146.528h-4.59l-2.585,1.335-4.081-1.335-2.6-2.616-2.013,2.616a1.981,1.981,0,0,0-1.981,1.981v14.753a1.981,1.981,0,0,0,1.981,1.981h15.87a1.981,1.981,0,0,0,1.981-1.981V148.509A1.981,1.981,0,0,0,178.607,146.528Z",
    transform: "translate(-133.54 -127.81)",
    fill: "#ff9a6e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11161",
    "data-name": "Path 11161",
    d: "M164.749,185.713h-2.012a1.981,1.981,0,0,1-1.981-1.981V168.978A1.981,1.981,0,0,1,162.736,167h2.012a1.982,1.982,0,0,0-1.981,1.981v14.753A1.982,1.982,0,0,0,164.749,185.713Z",
    transform: "translate(-160.755 -164.381)",
    fill: "#ff8c52"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11162",
    "data-name": "Path 11162",
    d: "M225.358,173.317l-.572-.732a.34.34,0,0,0-.536,0l-.575.736a.34.34,0,0,1-.536,0l-.575-.736a.34.34,0,0,0-.536,0l-.575.736a.34.34,0,0,1-.536,0l-.575-.736a.34.34,0,0,0-.536,0l-.572.732a.151.151,0,0,1-.271-.093V167h6.666v6.226A.152.152,0,0,1,225.358,173.317Z",
    transform: "translate(-212.367 -164.381)",
    fill: "#ffe471"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9477",
    "data-name": "Group 9477",
    transform: "translate(8.734 0.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9476",
    "data-name": "Group 9476"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11163",
    "data-name": "Path 11163",
    d: "M94.925,1.833h-4.59L87.75,3.168,83.669,1.833H79.054a1.981,1.981,0,0,0-1.981,1.981V18.567a1.981,1.981,0,0,0,1.981,1.981h15.87a1.981,1.981,0,0,0,1.981-1.981V3.814a1.981,1.981,0,0,0-1.981-1.981Z",
    transform: "translate(-77.073 -1.833)",
    fill: "#ff5a66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11164",
    "data-name": "Path 11164",
    d: "M81.067,20.547H79.054a1.981,1.981,0,0,1-1.981-1.981V3.812a1.981,1.981,0,0,1,1.981-1.981h2.012a1.982,1.982,0,0,0-1.981,1.981V18.566a1.982,1.982,0,0,0,1.981,1.981Z",
    transform: "translate(-77.073 -1.831)",
    fill: "#f2495e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11165",
    "data-name": "Path 11165",
    d: "M141.676,8.151l-.572-.732a.34.34,0,0,0-.536,0l-.575.736a.34.34,0,0,1-.536,0l-.575-.736a.34.34,0,0,0-.536,0l-.575.736a.34.34,0,0,1-.536,0l-.575-.736a.34.34,0,0,0-.536,0l-.572.732a.151.151,0,0,1-.271-.093V1.831h6.666V8.057A.152.152,0,0,1,141.676,8.151Z",
    transform: "translate(-128.685 -1.831)",
    fill: "#ffe471"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9481",
    "data-name": "Group 9481",
    transform: "translate(30.22 20.664)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -39.22, -20.46)",
    filter: "url(#Path_11166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11166-2",
    "data-name": "Path 11166",
    d: "M293.462,209.449v28a2.341,2.341,0,0,1-2.341,2.341H268.983a2.3,2.3,0,0,1-2.3-2.3V209.449a2.341,2.341,0,0,1,2.341-2.341h22.1A2.341,2.341,0,0,1,293.462,209.449Z",
    transform: "translate(-227.46 -183.85)",
    fill: "#cc7252"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11167",
    "data-name": "Path 11167",
    d: "M270.62,239.794h-1.635a2.3,2.3,0,0,1-2.3-2.3V209.45a2.341,2.341,0,0,1,2.341-2.341h1.635a2.341,2.341,0,0,0-2.341,2.341v28.042A2.3,2.3,0,0,0,270.62,239.794Z",
    transform: "translate(-266.683 -204.311)",
    fill: "#bc5f42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11168",
    "data-name": "Path 11168",
    d: "M309.093,265.2H289.446a1.036,1.036,0,0,1-1.036-1.036V239.934a1.036,1.036,0,0,1,1.036-1.036h19.647a1.036,1.036,0,0,1,1.036,1.036v24.233A1.036,1.036,0,0,1,309.093,265.2Z",
    transform: "translate(-285.948 -232.498)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11169",
    "data-name": "Path 11169",
    d: "M290.909,265.2h-1.462a1.036,1.036,0,0,1-1.036-1.037V239.932a1.037,1.037,0,0,1,1.036-1.037h1.462a1.037,1.037,0,0,0-1.036,1.037v24.232A1.037,1.037,0,0,0,290.909,265.2Z",
    transform: "translate(-285.948 -232.495)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11170",
    "data-name": "Path 11170",
    d: "M328.013,184.894a2.474,2.474,0,0,0-2.474-2.474H313.832a2.474,2.474,0,0,0-2.474,2.474v.345a2.474,2.474,0,0,0,2.474,2.474h1.231a2.474,2.474,0,0,0,2.474,2.474h4.3a2.474,2.474,0,0,0,2.474-2.474h1.231a2.474,2.474,0,0,0,2.474-2.474Z",
    transform: "translate(-306.296 -182.42)",
    fill: "#ffe471"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11171",
    "data-name": "Path 11171",
    d: "M319.586,190.19h-2.047a2.476,2.476,0,0,1-2.474-2.474h-1.231a2.475,2.475,0,0,1-2.474-2.474V184.9a2.474,2.474,0,0,1,2.474-2.474h2.047a2.474,2.474,0,0,0-2.474,2.474v.346a2.475,2.475,0,0,0,2.474,2.474h1.231a2.476,2.476,0,0,0,2.474,2.474Z",
    transform: "translate(-306.296 -182.421)",
    fill: "#ffd473"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11172",
    "data-name": "Path 11172",
    d: "M350.126,200.349h-8.343a.8.8,0,1,1,0-1.6h8.343a.8.8,0,1,1,0,1.6Z",
    transform: "translate(-332.564 -196.9)",
    fill: "#ffd473"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9478",
    "data-name": "Group 9478",
    transform: "translate(4.426 8.915)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11173",
    "data-name": "Path 11173",
    d: "M311.226,261.094h-.762l-1.371.825-1.371-.825h-.762a1.215,1.215,0,0,0-1.215,1.215v4.267a1.215,1.215,0,0,0,1.215,1.215h4.267a1.215,1.215,0,0,0,1.215-1.215v-4.267A1.216,1.216,0,0,0,311.226,261.094Z",
    transform: "translate(-305.744 -261.094)",
    fill: "#ff5a66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11174",
    "data-name": "Path 11174",
    d: "M325.486,264.04l-.777-.4a.31.31,0,0,0-.283,0l-.777.4a.31.31,0,0,1-.452-.276v-2.671h2.742v2.671A.31.31,0,0,1,325.486,264.04Z",
    transform: "translate(-321.218 -261.093)",
    fill: "#ffe471"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9479",
    "data-name": "Group 9479",
    transform: "translate(4.426 16.756)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11175",
    "data-name": "Path 11175",
    d: "M311.226,330.288h-.762l-1.371.825-1.371-.825h-.762a1.215,1.215,0,0,0-1.215,1.215v4.267a1.215,1.215,0,0,0,1.215,1.215h4.267a1.215,1.215,0,0,0,1.215-1.215V331.5A1.215,1.215,0,0,0,311.226,330.288Z",
    transform: "translate(-305.744 -330.288)",
    fill: "#ffe471"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11176",
    "data-name": "Path 11176",
    d: "M325.486,333.234l-.777-.4a.31.31,0,0,0-.283,0l-.777.4a.31.31,0,0,1-.452-.276v-2.671h2.742v2.671A.31.31,0,0,1,325.486,333.234Z",
    transform: "translate(-321.218 -330.287)",
    fill: "#ff9a6e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9480",
    "data-name": "Group 9480",
    transform: "translate(4.426 24.597)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11177",
    "data-name": "Path 11177",
    d: "M311.226,399.482h-.762l-1.371.825-1.371-.825h-.762a1.215,1.215,0,0,0-1.215,1.215v4.267a1.215,1.215,0,0,0,1.215,1.215h4.267a1.215,1.215,0,0,0,1.215-1.215V400.7A1.216,1.216,0,0,0,311.226,399.482Z",
    transform: "translate(-305.744 -399.482)",
    fill: "#ff9a6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11178",
    "data-name": "Path 11178",
    d: "M325.486,402.428l-.777-.4a.31.31,0,0,0-.283,0l-.777.4a.31.31,0,0,1-.452-.276v-2.671h2.742v2.671A.31.31,0,0,1,325.486,402.428Z",
    transform: "translate(-321.218 -399.481)",
    fill: "#ffe471"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9482",
    "data-name": "Group 9482",
    transform: "translate(44.743 28.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11179",
    "data-name": "Path 11179",
    d: "M398.7,259.8a1.134,1.134,0,0,1-.738-.274l-2.719-2.337a1.133,1.133,0,1,1,1.477-1.719l1.65,1.418,2.061-3.835a1.133,1.133,0,0,1,2,1.073L399.7,259.2a1.133,1.133,0,0,1-1,.6Z",
    transform: "translate(-394.852 -252.453)",
    fill: "#4dc177"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11180",
    "data-name": "Path 11180",
    d: "M398.7,329.766a1.133,1.133,0,0,1-.738-.274l-2.719-2.336a1.133,1.133,0,1,1,1.477-1.719l1.65,1.418,2.061-3.835a1.133,1.133,0,0,1,2,1.073l-2.728,5.077a1.134,1.134,0,0,1-1,.6Z",
    transform: "translate(-394.852 -314.494)",
    fill: "#4dc177"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11181",
    "data-name": "Path 11181",
    d: "M398.7,399.734a1.133,1.133,0,0,1-.738-.274l-2.719-2.336a1.133,1.133,0,0,1,1.477-1.719l1.65,1.418,2.061-3.835a1.133,1.133,0,0,1,2,1.073l-2.728,5.077a1.133,1.133,0,0,1-1,.6Z",
    transform: "translate(-394.852 -376.534)",
    fill: "#4dc177"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStockTakeIcon);
export default __webpack_public_path__ + "static/media/stock-take-icon.53f5bc5f0c5749261047e17c44fa61b7.svg";
export { ForwardRef as ReactComponent };